import { RouteParameters } from 'constants/'
import { useCountry } from 'hooks'
import { EditAppointment } from 'modules/EditAppointment'
import { NotFound } from 'modules/NotFound'
import { useMemo } from 'react'
import { Route, Routes } from 'react-router'
import { isCountrySupported } from '../../../util'
import { Appointments } from '../../Appointments'
import { Consultant } from '../../Consultant'
import { CountryNotSupported } from '../../CountryNotSupported'
import { CreateAppointment } from '../../CreateAppointment'
import { Reservation } from '../../Reservation'
import { Schedule } from '../../Schedule'
import { Settings } from '../../Settings'
import { SchedulingV2Redirect } from './SchedulingV2Redirect'

export const CountrySpecificRoutes = () => {
  const country = useCountry()

  const isValidCountry = useMemo(() => isCountrySupported(country), [])

  if (!isValidCountry) return <CountryNotSupported />

  return (
    <>
      <SchedulingV2Redirect />
      <Routes>
        <Route element={<Appointments />} path={`/appointments/*`} />
        <Route element={<Settings />} path={`/settings/*`} />
        <Route element={<Consultant />} path={`/consultant/*`} />
        <Route element={<Reservation />} path={`/reservation/*`} />
        <Route element={<Schedule />} path={`/schedule/*`} />
        <Route element={<CreateAppointment />} path={`/customer/:${RouteParameters.CUSTOMER_GID}/create-appointment/*`} />
        <Route
          element={<EditAppointment />}
          path={`/customer/:${RouteParameters.CUSTOMER_GID}/appointment/:${RouteParameters.APPOINTMENT_GID}/edit/*`}
        />
        <Route element={<NotFound />} path="*" />
      </Routes>
    </>
  )
}
